import { useState, useEffect } from 'react';
import { configurationService, AppConfiguration } from '../services';
import { Language } from '../constants/language';
import { Currency } from '../constants/currency';

/**
 * Custom hook to use app configuration
 */
export const useConfiguration = () => {
  const [config, setConfig] = useState<AppConfiguration>(configurationService.getConfiguration());

  useEffect(() => {
    // Subscribe to configuration changes
    const unsubscribe = configurationService.subscribe((newConfig) => {
      setConfig(newConfig);
    });

    // Cleanup subscription
    return unsubscribe;
  }, []);

  return {
    // Current configuration
    config,
    language: config.language,
    currency: config.currency,
    region: config.region,
    
    // Update methods
    setLanguage: (language: Language) => configurationService.setLanguage(language),
    setCurrency: (currency: Currency) => configurationService.setCurrency(currency),
    setRegion: (region: string) => configurationService.setRegion(region),
    setConfiguration: (config: Partial<AppConfiguration>) => configurationService.setConfiguration(config),
    
    // Utility methods
    clearCache: () => configurationService.clearCache(),
  };
};